export const FILTER_OPTIONS_ADVERTISER_QUERY = {
    view: "explore_conversion_suggests",
    fields: ["conversion_meta_inst.advertiser__name", "conversion_meta_inst.advertiser__id"],
    filters: {
        "billable_agg.filter_date_nyc": ""
    },
    sorts: ["conversion_meta_inst.advertiser__name asc"],
    limit: "-1",
    column_limit: "500",
    model: "client_analytics"
};
export const FILTER_OPTIONS_PUBLISHER_QUERY = {
    view: "explore_conversion_suggests",
    fields: ["conversion_meta_pub.name", "billable_agg.publisher_id"],
    filters: {
        "billable_agg.filter_date_nyc": ""
    },
    sorts: ["conversion_meta_pub.name asc"],
    limit: "-1",
    column_limit: "500",
    model: "client_analytics"
};
export const FILTER_OPTIONS_CAMPAIGN_QUERY = {
    view: "explore_conversion_suggests",
    fields: [
        "conversion_meta_inst.campaign__name",
        "conversion_meta_inst.campaign__id",
        "conversion_meta_inst.lineitem__id"
    ],
    filters: {
        "billable_agg.filter_date_nyc": ""
    },
    sorts: ["conversion_meta_inst.campaign__name desc"],
    limit: "-1",
    column_limit: "500",
    model: "client_analytics"
};
export const FILTER_OPTIONS_BUNDLE_QUERY = {
    view: "explore_conversion_suggests",
    fields: ["billable_agg.bundle"],
    filters: {
        "billable_agg.filter_date_nyc": "",
        "billable_agg.publisher_id": ""
    },
    sorts: ["billable_agg.bundle asc"],
    limit: "-1",
    column_limit: "500",
    model: "client_analytics"
};
export const FILTER_OPTIONS_CHANNEL_QUERY = {
    view: "explore_conversion_suggests",
    fields: ["billable_agg.channel"],
    filters: {
        "billable_agg.filter_date_nyc": "",
        "billable_agg.publisher_id": ""
    },
    sorts: ["billable_agg.channel asc"],
    limit: "-1",
    column_limit: "500",
    model: "client_analytics"
};
export const FILTER_OPTIONS_PRODUCT_TYPE_QUERY = {
    view: "explore_conversion_suggests",
    fields: ["billable_agg.media_subtype"],
    filters: {
        "billable_agg.filter_date_nyc": "",
        "billable_agg.publisher_id": ""
    },
    sorts: ["billable_agg.media_subtype asc"],
    limit: "-1",
    column_limit: "500",
    model: "client_analytics"
};
export const INVENTORY_QUERY = {
    view: "delivery",
    fields: [],
    filters: {
        "delivery_explore.flt_analysis_interval": ""
    },
    sorts: [],
    limit: "-1",
    column_limit: "50",
    model: "client_analytics"
};
//# sourceMappingURL=query.js.map